export const EMOJI_CHOICES = [
  "🦊", "🐼", "🐧", "🐨", "🐸", "🐙", "🦁", "🐯",
  "🐵", "🦄", "🐝", "🦋", "🌸", "🌈", "⭐", "🚀",
  "🎨", "🎸", "🍕", "🍩", "🌮", "⚽", "🏀", "🎲",
];
